/* eslint-disable sonarjs/no-duplicate-string */

import { regionList } from 'system/libs/regionList';

define((require) => {
    'use strict';

    const FormLayer = require('system/blocks/form-layer/form-layer');

    require('toolkit/b-select/b-select');

    return FormLayer.extend('billing-registration__stage-legal-address', {
        inner: true,
        renderMode: 'replace',
        service: false,

        title: 'Дорегистрация',

        onAccept() {
            const form = this._form;
            let data;

            if (form.validate()) {
                data = this.getFormData();

                this.emit('complete', data);
            }
        },

        onRollback() {
            const data = this.getFormData();

            this.emit('back', data);
        },

        onClose() {
            this.emit('cancel');
        },

        width: 420,

        classes: ['billing-registration__stage-legal-address'],

        mods: [
            'centered-header',
            'billing-registration',
            'billing-registration__stage-legal-address',
        ],

        buttons: [
            {
                name: 'rollback',
                text: 'Вернуться',
            },
            {
                block: 'dot-pager',
                dotCount: 2,
                activeDot: 2,
                mods: ['center'],
            },
            {
                name: 'accept',
                text: 'Подтвердить',
                mods: ['main', 'right', 'single'],
            },
        ],

        fields(data) {
            const defs = this.defs;
            const region = String(data[defs.LEGAL_REGION]);

            return [
                {
                    columns: [
                        {
                            block: 'b-form-section-label',
                            text: 'Юридический адрес',
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-select',
                            label: 'Регион',
                            mods: ['responsive'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный регион',
                                },
                                {
                                    type: 'required',
                                    text: 'Выберите регион',
                                },
                            ],
                            props: {
                                name: defs.LEGAL_REGION,
                                tabindex: 1,
                                required: true,
                            },
                            items: this._getRegionItems(region),
                            defaultIndex: 0,
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'Почтовый индекс',
                            mods: [
                                'compact',
                                'popup',
                                'stretch',
                                'biling-registration-post-index',
                            ],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный почтовый индекс',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните почтовый индекс',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.LEGAL_POST,
                                value: data[defs.LEGAL_POST],
                                tabindex: 2,
                                required: true,
                            },
                        },
                        {
                            block: 'b-input',
                            label: 'Город',
                            mods: [
                                'responsive',
                                'compact',
                                'popup',
                                'default-wigth',
                            ],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный город',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните город',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.LEGAL_CITY,
                                value: data[defs.LEGAL_CITY],
                                tabindex: 3,
                                required: true,
                            },
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'Улица',
                            mods: [
                                'responsive',
                                'compact',
                                'popup',
                                'default-wigth',
                            ],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверная улица',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.LEGAL_STREET,
                                value: data[defs.LEGAL_STREET],
                                tabindex: 4,
                            },
                        },
                        {
                            block: 'b-input',
                            label: 'Номер дома',
                            mods: [
                                'compact',
                                'popup',
                                'stretch',
                                'biling-registration-house',
                            ],
                            errors: [
                                {
                                    type: 'invalid',
                                    text:
                                        'Неверный номер дома (пример: 39\u00A0стр\u00A079)',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.LEGAL_HOUSE,
                                value: data[defs.LEGAL_HOUSE],
                                tabindex: 5,
                            },
                        },
                    ],
                },
            ];
        },

        _getRegionItems(regionCode) {
            const items = regionList.map((region) => {
                return {
                    text: region.name,
                    value: region.code,
                    selected: region.code === regionCode,
                };
            });

            items.unshift({
                text: 'Выберите регион',
            });

            return items;
        },
    });
});
